export default "__VITE_ASSET__ePAeFrwk__"